import { render, staticRenderFns } from "./Sub.vue?vue&type=template&id=4561f55c&"
import script from "./Sub.vue?vue&type=script&lang=js&"
export * from "./Sub.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports